export const LABEL_DETAILS_LABELS = {
	SECTION_TITLE: 'Label details',
	DISPLAY_NAME_LABEL: 'Key display name',
	DISPLAY_NAME_TOOLTIP: 'The name shown in the UI for this label key',
	DESCRIPTION_LABEL: 'Key description',
	DESCRIPTION_TOOLTIP: "Explain the key's purpose or intended use",
	DESCRIPTION_PLACEHOLDER: "Explain the key's purpose or intended use"
} as const;
